// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { OperatorConfiguration } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Configuration/Operator';
import { ERR_MOD_OP_CONF, SUC_MOD_OP_CONF } from '../../../../utils/strings';

const useModifyOperatorConfiguration = () => {
  const { submit } = useExerciseSubmission(
    OperatorConfiguration.OperatorConfiguration_Modify,
    SUC_MOD_OP_CONF,
    ERR_MOD_OP_CONF,
  );

  return submit;
};

export default useModifyOperatorConfiguration;
